import { useEffect, useState } from "react"
import initializeAuthentication from "../Firebase/firebase.init";
import { GoogleAuthProvider, getAuth, signInWithPopup, signOut, onAuthStateChanged } from "firebase/auth";


initializeAuthentication();

const useFirebase = () => {
    const [user, setUser] = useState({});
    const [error, setError] = useState('');
    const auth = getAuth()
    const provider = new GoogleAuthProvider();

    const signInUsingGoogle = () => {
        signInWithPopup(auth, provider)
            .then(result => {
                console.log(result.user)
                setUser(result.user)
            })
            .catch(error => {
                setError(error.message)
            })
    }

    const logOut = () => {
        signOut(auth)
            .then(() => {
                setUser({})
            })
    }
    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                console.log('inside', user)
                setUser(user)
            }
        })
    }, [])

    return {
        user,
        error,
        logOut,
        signInUsingGoogle
    }
};

export default useFirebase;